import React, { FC } from 'react';

import {
  NavigationBasicItemProps,
  NavigationWithSplitterItemProps,
} from './models';
import { NavigationBasicItem } from './navigation-basic-item';
import { NavigationWithSplitterItem } from './navigation-with-splitter-item';

export type {
  NavigationBasicItemProps,
  NavigationWithSplitterItemProps,
} from './models';
export { NavigationBasicItem } from './navigation-basic-item';

const isWithSplitter = (props): props is NavigationWithSplitterItemProps =>
  !!props.submenu;

export const NavigationItem: FC<
  NavigationBasicItemProps | NavigationWithSplitterItemProps
> = (props) =>
  isWithSplitter(props) ? (
    <NavigationWithSplitterItem {...props} />
  ) : (
    <NavigationBasicItem {...props} />
  );
